<template>
	<div class="block">
		<p>角色管理</p>
			<el-tree :data="data"  node-key="id" default-expand-all :expand-on-click-node="false">
				<span class="custom-tree-node" slot-scope="{ node, data }">
					<span>{{ node.label }}</span>
					<span class="btn_warp">
						<el-button type="text" size="medium" @click="() => append(data)">
							添加角色
						</el-button>
						<el-button type="text" size="medium" @click="() => modify(data)" :disabled="currentHr.roles[0].roleId == data.roleId">
							修改角色
						</el-button>
						<el-button type="text" size="medium" @click="() => queryUsers(data)" :disabled="currentHr.roles[0].roleId == data.roleId">
							查看用户
						</el-button>
						<el-button type="text" size="medium" @click="() => remove(node, data)" :disabled="currentHr.roles[0].roleId != '1001' || data.roleId == '1001'">
							删除角色
						</el-button>
						<el-button type="text" size="medium" @click="() => permisson(node, data)" :disabled="data.roleId == '1001' || currentHr.roles[0].roleId == data.roleId">
							权限设置
						</el-button>
					</span>
				</span>
			</el-tree>

		<el-dialog
		        :title="title"
		        :visible.sync="dialogVisible"
				:before-close="handlePopClose"
		        width="50%">
		    <div>
				<el-form :model="roleInfo" :rules="rules" ref="empForm">
				    <el-row>
				        <el-col :span="12">
				            <el-form-item label="角色名称:" prop="label">
								<div class="input_box">
									<el-input size="mini" style="width: 250px" prefix-icon="el-icon-edit" v-model="roleInfo.label"
									          placeholder="请输入角色名称" maxlength="50" show-word-limit></el-input>
								</div>
				            </el-form-item>
				        </el-col>
					</el-row>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="closeRolePop">取 消</el-button>
					<el-button type="primary" @click="doAddEmp">确 定</el-button>
				</span>
			</div>
		</el-dialog>
		<el-dialog
		        title="权限设置"
		        :visible.sync="permissonDialogVisible"
		        width="70%"
				:before-close="handlePermissonPopClose"
				>
		    <div class="pop_block_warp">
				<div class="item_block">
					<p>菜单权限</p>
					<div class="treeWarp">
						<el-tree :data="allMenu" show-checkbox node-key="id" default-expand-all :expand-on-click-node="false" ref="menusTree">
							<span class="custom-tree-node" slot-scope="{ node, data }" >
								<span>{{ data.name }}</span>
							</span>
						</el-tree>
					</div>

				</div>
				<div class="item_block">
					<p>数据权限</p>
					<el-input
					  placeholder="输入关键字进行过滤"
					  v-model="filterText">
					</el-input>
					<div class="treeWarp">
						<el-tree :data="tenants" show-checkbox node-key="ktiId" default-expand-all
							:expand-on-click-node="false" ref="tenantsTree" :filter-node-method="filterTenantNode">
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>{{ data.ktiName }}</span>
							</span>
						</el-tree>
					</div>
				</div>
				<div class="item_block">
					<p>辩证病种权限</p>
					<el-input
					  placeholder="输入关键字进行过滤"
					  v-model="filterQuestionModelText">
					</el-input>
					<div class="treeWarp">
						<el-tree :data="questionModels" show-checkbox node-key="kqmId" default-expand-all
							:expand-on-click-node="false" ref="questionModelsTree" :filter-node-method="filterQuestionModelNode">
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>{{ data.kqmName }}</span>
							</span>
						</el-tree>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closePermissonPop">取 消</el-button>
				<el-button type="primary" @click="addPermission">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog
		        title="角色用户"
		        :visible.sync="userInfoDialogVisible"
		        width="70%"
				:before-close="handleRoleUsersPopClose"
				>
				<div>
					<el-table
					    :data="roleUsers"
					    height="250"
					    border
					    style="width: 100%">
					    <el-table-column
					      prop="name"
					      label="用户姓名"
					      min-width="25%">
					    </el-table-column>
					    <el-table-column
					      prop="username"
					      label="登录名"
					      min-width="25%">
					    </el-table-column>
					    <el-table-column
					      prop="pwdnew"
						  min-width="25%"
					      label="密码">
						  <template slot-scope="scope">
						  	<div v-if="scope.row.pwdnew != null">{{scope.row.pwdnew}}</div>
						  	<div v-else>{{scope.row.username}}</div>
						  </template>
					    </el-table-column>
						<el-table-column
						  prop="phone"
						  label="联系方式"
						  min-width="25%">
						</el-table-column>
					  </el-table>
				</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex';
	export default {
		data() {
			return {
				data: null,
				dialogVisible:false,
				permissonDialogVisible:false,
				userInfoDialogVisible:false,
				roleInfo:{
					id:'',
					label:'',
					proleId:''
				},
				rules: {
				    label: [{required: true, message: '请输入角色名称', trigger: 'blur'}]
				},
				roleUsers:[],
				title:'',
				allMenu:[],
				tenants:[],
				filterText:'',
				filterQuestionModelText:'',
				tenantCheckedKeys:[],
				menuCheckedKeys:[],
				permissionRoleId:'',
				questionModels:[]
			}
		},
		computed:{
			...mapState([
			      'currentHr' // 将 `this.count` 映射为 `store.state.count`
			]),
		},
		created() {
			this.getTreeData()
			this.getAllMenuTree()
			this.getTenantsAllList()
			this.getQuestionModelListByRole()
		},
		mounted() {

		},
		watch: {
		    filterText(val) {
		        this.$refs.tenantsTree.filter(val);
		    },
			filterQuestionModelText(val){
				this.$refs.questionModelsTree.filter(val);
			}
		},
		methods: {
			closePermissonPop(){
				this.filterText = ''
				this.filterQuestionModelText = ''
				this.$refs.questionModelsTree.setCheckedKeys([]);
				this.$refs.tenantsTree.setCheckedKeys([]);
				this.$refs.menusTree.setCheckedKeys([]);
				this.permissonDialogVisible = false
			},
			handlePopClose(done){
				this.emptyRoleInfo();
				done();
			},
			handlePermissonPopClose(done){
				this.filterText = ''
				this.filterQuestionModelText = ''
				this.$refs.questionModelsTree.setCheckedKeys([]);
				this.$refs.tenantsTree.setCheckedKeys([]);
				this.$refs.menusTree.setCheckedKeys([]);
				
				console.log("关闭清空")
				done();
			},
			handleRoleUsersPopClose(done){
				this.roleUsers = [];
				console.log("关闭清空")
				done();
			},
			closeRolePop(){
				this.emptyRoleInfo();
				this.dialogVisible = false
			},
			addPermission(){
				this.menuCheckedKeys =  this.$refs.menusTree.getCheckedKeys()
				this.tenantCheckedKeys = this.$refs.tenantsTree.getCheckedKeys()
				this.questionModelCheckedKeys = this.$refs.questionModelsTree.getCheckedKeys()
				console.log(this.menuCheckedKeys)
				console.log(this.tenantCheckedKeys)
				console.log(this.questionModelCheckedKeys)
				var title = '设置角色权限，是否继续?'
				if(this.menuCheckedKeys.length == 0 && this.tenantCheckedKeys.length == 0 && this.questionModelCheckedKeys.length == 0){
					this.$message({
					    type: 'warning',
					    message: '请选择数据'
					});
					return;
				}
				if(this.menuCheckedKeys.length == 0){
					title = '您未选择菜单权限，是否继续?'
				}
				if(this.tenantCheckedKeys.length == 0){
					title = '您未选择数据权限，是否继续?'
				}
				if(this.questionModelCheckedKeys.length == 0){
					title = '您未选择辩证病种权限，是否继续?'
				}
				this.$confirm(title, '提示', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				}).then(() => {
					this.postRequest("/system/basic/permiss/setRolePermission", {
						roleId:this.permissionRoleId,
						menuCheckedKeys:this.menuCheckedKeys,
						tenantCheckedKeys:this.tenantCheckedKeys,
						questionModelCheckedKeys:this.questionModelCheckedKeys
					}).then(resp => {
					    if (resp) {
							this.$refs.tenantsTree.setCheckedKeys([]);
							this.$refs.menusTree.setCheckedKeys([]);
							this.$refs.questionModelsTree.setCheckedKeys([]);
							this.permissionRoleId = ''
							this.permissonDialogVisible = false
					    }
					})
				}).catch(() => {
				    
				});
			},
			filterTenantNode(value, data){
				if (!value) return true;
				return data.ktiName.indexOf(value) !== -1;
			},
			filterQuestionModelNode(value, data){
				if (!value) return true;
				return data.kqmName.indexOf(value) !== -1;
			},
			async getTreeData(){
				this.getRequest('/system/hr/treeRoles').then(resp => {
				    if (resp) {
						console.log(resp)
						this.data = JSON.parse(JSON.stringify(resp))
				    }
				});
			},
			async getTenantsAllList(){
				this.getRequest('/tenant/basic/getTenantsAllList').then(resp => {
				    if (resp) {
						console.log(resp)
						this.tenants = JSON.parse(JSON.stringify(resp.obj))
				    }
				});
			},
			async getQuestionModelListByRole(){
				this.getRequest('/tenant/basic/getQuestionModelListByRole').then(resp => {
				    if (resp) {
						console.log(resp)
						this.questionModels = JSON.parse(JSON.stringify(resp.obj))
				    }
				});
			},
			async getAllMenuTree(){
				this.getRequest('/system/config/menu').then(resp => {
				    if (resp) {
						console.log(resp)
						this.allMenu = JSON.parse(JSON.stringify(resp))
				    }
				});
			},
			permisson(node,data){
				console.log(data)
				this.permissionRoleId = data.id
				this.permissonDialogVisible = true
				this.getPermissionMenuByRole(this.permissionRoleId)
				this.getPermissionTenantByRole(this.permissionRoleId)
				this.getPermissionQuesModelsByRole(this.permissionRoleId)
			},
			async getPermissionMenuByRole(roleId){
				this.getRequest('/system/config/permission/menu/' + roleId).then(resp => {
				    if (resp.status == 200) {
						console.log(resp)
						this.$refs.menusTree.setCheckedKeys(resp.obj);
				    }
				});
			},
			async getPermissionTenantByRole(roleId){
				this.getRequest('/system/config/permission/tenant/' + roleId).then(resp => {
				    if (resp.status == 200) {
						console.log(resp)
						this.$refs.tenantsTree.setCheckedKeys(resp.obj);
				    }
				});
			},
			async getPermissionQuesModelsByRole(roleId){
				this.getRequest('/system/config/permission/questionModel/' + roleId).then(resp => {
				    if (resp.status == 200) {
						console.log(resp)
						this.$refs.questionModelsTree.setCheckedKeys(resp.obj);
				    }
				});
			},
			async getUpmsInfoByRoleId(roleId){
				this.getRequest('/userManager/basic/getUpmsInfoByRoleId/' + roleId).then(resp => {
				    if (resp.status == 200) {
						this.roleUsers = resp.obj
				    }
				});
			},
			append(data) {
				console.log(data)
				this.title = '添加角色'
				this.roleInfo.proleId = data.roleId
				this.dialogVisible = true
				/* const newChild = {
					id: id++,
					label: 'testtest',
					children: []
				};
				if (!data.children) {
					this.$set(data, 'children', []);
				}
				data.children.push(newChild); */
			},
			modify(data){
				console.log(data)
				this.title = '修改角色'
				this.roleInfo.id = data.id
				this.roleInfo.label = data.label
				this.dialogVisible = true
			},
			queryUsers(data){
				console.log(data)
				this.getUpmsInfoByRoleId(data.id)
				this.userInfoDialogVisible = true
			},
			emptyRoleInfo(){
				this.roleInfo.proleId = ''
				this.roleInfo.label = ''
				this.roleInfo.id = ''
			},
			doAddEmp(){
				if (this.roleInfo.id) {
					this.$refs['empForm'].validate(valid => {
					    if (valid) {
							this.postRequest("/system/basic/permiss/updateRole", this.roleInfo).then(resp => {
							    if (resp) {
							        this.dialogVisible = false;
									this.emptyRoleInfo();
							        this.getTreeData();
							    }
							})
						}
					})
				}else{
					this.$refs['empForm'].validate(valid => {
					    if (valid) {
							this.postRequest("/system/basic/permiss/addRole", this.roleInfo).then(resp => {
							    if (resp) {
							        this.dialogVisible = false;
									this.emptyRoleInfo();
							        this.getTreeData();
							    }
							})
						}
					})
				}
				
			},
			remove(node, data) {
				console.log(node,data)
				this.$confirm("确定要删除该角色【"+data.label+"】吗？", '提示', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				}).then(() => {
					this.$confirm("确定要删除该角色【"+data.label+"】吗？", '提示', {
					    confirmButtonText: '确定',
					    cancelButtonText: '取消',
					    type: 'warning'
					}).then(() => {
						this.postRequest("/system/basic/permiss/deleteRole", data).then(resp => {
						    if (resp) {
						        this.dialogVisible = false;
								this.emptyRoleInfo();
						        this.getTreeData();
						    }
						})
					}).catch(() => {
					    
					});
				}).catch(() => {
				    
				});
				
			},
		}
	}
</script>

<style scoped lang="scss">
	::v-deep .el-dialog__footer {
		text-align: center !important;
	}
	::v-deep .custom-tree-node {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.pop_block_warp {
		display: flex;
		justify-content: space-around;
		align-items: flex-start;

		p {
			
		}
		.item_block {
			width: 50%;
			padding: 20px;
			.treeWarp {
				height: 46vh;
				overflow-y: scroll;
			}

		}
		.item_block:first-child {
			border-right: 1px solid #eff2f6;
		}
	}
	.block {
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.tree_warp {
		/* max-height: 70vh;
		overflow-y: scroll;
		display: flex;
		min-width: 60%; */
	}
	.btn_warp {
		margin-left: 66px;
		font-size: 28px;
	}
	::v-deep .el-tree-node__content {
		margin-top: 10px !important;
	}
</style>